import { usePageTitle } from "hooks/usePageTitle";
import DashboardContainer from "components/dashboard/DashboardContainer";
import { HANDBOOK_URL } from "constants/staticUrls";

export const HandbookApp = () => {
  usePageTitle("Handbook");

  return (
    <DashboardContainer className="t-h-full">
      <DashboardContainer.Header>
        <div className="t-absolute t-w-full t-h-[60px] t-bg-surface"></div>
      </DashboardContainer.Header>
      <DashboardContainer.Content>
        <iframe
          title="handbook"
          src={HANDBOOK_URL}
          className="t-h-full t-w-full"
        />
      </DashboardContainer.Content>
    </DashboardContainer>
  );
};
